import React from 'react'
import PropTypes from 'prop-types'

import DropShadowFilter from 'app/components/SVGS/DropShadowFilter'
import StreakLine from './StreakLine'
import MissedLine from './MissedLine'

import { getGraphElements } from './methods'

const ChartBody = ({ width, noPaddingWidth, activities, isMobile, resizeRef }) => {
  const graphItems = getGraphElements({
    activities,
    isMobile,
    innerWidth: noPaddingWidth,
    innerHeight: isMobile ? 100 : 200,
  })
  return (
    <div ref={resizeRef}>
      <svg width={width} height={isMobile ? 130 : 200} ref={resizeRef}>
        <g>
          {graphItems.filter(item => !item.completed).map((item, index) => <MissedLine key={index} {...item} />)}
          {graphItems
            .filter(item => item.completed)
            .reverse()
            .map((item, index) => <StreakLine key={index} {...item} />)}
        </g>
        <DropShadowFilter />
      </svg>
    </div>
  )
}

ChartBody.propTypes = {
  width: PropTypes.number.isRequired,
  noPaddingWidth: PropTypes.number.isRequired,
  activities: PropTypes.array.isRequired,
  isMobile: PropTypes.bool.isRequired,
  resizeRef: PropTypes.func.isRequired,
}

export default ChartBody
